import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import FloatingWhatsApp from "@/components/ui/FloatingWhatsApp";
import { Toaster } from "@/components/ui/sonner";

// Scrolls to top on every route change.
function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

// ---------------------------------------------------------------------------
// Third-party code injection is handled entirely on the server. The `ssr`
// Cloud Function reads the administrator's approved header/body snippets and
// writes them into the HTML before it is served, so tracking tags run on the
// first paint and the browser is never asked to evaluate script it received as
// data. Nothing to do here.
// ---------------------------------------------------------------------------

export default function Layout() {
    return (
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
            <ScrollToTop />
            <Navbar />
            <main className="min-h-screen">
                <Outlet />
            </main>
            <Footer />
            <FloatingWhatsApp />
            <Toaster position="top-center" richColors />
        </ReactLenis>
    );
}
